import React, { useState, useEffect, useStyles } from "react";
import { withTranslation } from "react-i18next";
import {
  contentClient,
  discussionClient,
} from "../../AxiosClient";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
function ExpertModeratorItem(props) {
  const [docData, setDocData] = useState({});
  const [discData, setDiscData] = useState({});

  useEffect(() => {getData()}, [props.user]);
  const getData = () => {
    contentClient
      .get(
        `/summary/user/${props.user.userId}/taxonomy/${
          props.node.id
        }/documentdata`
      )
      .then((res) => {
        setDocData(res.data);
      });
    discussionClient
      .get(
        `/discussion/taxonomy/${props.node.id}/user/${props.user.userId}/data`
      )
      .then((res) => {
        setDiscData(res.data);
      });
  };
  return (
    <>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>{props.t("num_documents_authored")}</TableCell>
            <TableCell>{docData.numberOfDocuments}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              {props.t("num_documents_authored_for_taxonomy")}
            </TableCell>
            <TableCell>{docData.numberOfDocumentsForTax}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{props.t("discussions_authored")}</TableCell>
            <TableCell>{discData.numberOfDiscussions}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              {props.t("discussions_authored_for_taxonomy")}
            </TableCell>
            <TableCell>{discData.numberOfDiscussionsForTaxonomy}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}

export default withTranslation()(ExpertModeratorItem);
